import React, { Component } from 'react'

import Button from './Button'

import * as INGREDIENTS from '../data/ingredients.json'

class LandingPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      clickHandler: props.clickHandler,
      ingredientIndex: 0,
    };

    this.changeIngredient = this.changeIngredient.bind(this);

    setInterval(this.changeIngredient, 1000);
  }

  changeIngredient() {
    this.setState({
      ingredientIndex: (this.state.ingredientIndex + 1) % INGREDIENTS.landingPageRotator.length
    });
  }

  render() {
    return (
      <div className="landing-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-5 offset-lg-1">
              <div className="landing-page__text">
              <img src="images/sandwich-stack.svg" alt="Stacked Sandwiches" className="landing-page__sandwich d-md-none" />
                <div className="landing-page__text landing-page__preheading">National</div>
                <img src="images/graphic-text/peanutbutter-sandwich-day.svg" alt="Peanut Butter Sandwich Day!" className="landing-image d-none d-md-block" />
                <img src="images/graphic-text/peanutbutter-sandwich-day-center.svg" alt="Peanut Butter Sandwich Day!" className="landing-image-sm d-md-none" />
                <div className="landing-page__text landing-page__ingredient-suggestions">Peanut butter and {INGREDIENTS.landingPageRotator[this.state.ingredientIndex]}. <br /> The possibilities are endless.</div>
                <div className="landing-page__text landing-page__large">02/24/22</div>
                
                <Button clickHandler={this.state.clickHandler} text="Make Me a Sandwich!" />
                <div className="landing-page__footer col-12">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="landing-page__footer-wrap">
                        <div className="landing-page__byline">Brought to you by</div>
                        <a href="https://www.neboagency.com/" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 42" width="124" height="42" className="landing-page__logo">
                            <path d="M0,41.1h10.6l5.5-23.7c0,0,0.6-2.9,3.6-2.9c2.9,0,2.3,2.9,2.3,2.9l-4,17.3c-0.7,2.9-0.9,7.3,4.3,7.3c2.5,0,9-4.1,9.4-4.3c0.4-0.2,0.9-1,0.2-2.3l-1.8,0.9c0,0-1.2,0.8-0.7-1.4L32.7,21c1.4-5.4-2.5-10.4-7.7-10.4c-5.3,0-7.6,2.8-7.6,2.8l0.4-1.8H4.4l-0.5,1.7c0,0,2.4,0.4,1.8,2.7L0,41.1z"/>
                            <path d="M46.1,42c-11.7,0-13.5-4.9-11.8-12.2c0,0,0.3-1.5,1.7-7.5c1.4-6,6.8-11.7,16.2-11.7c9.1,0,11.1,4.4,11.1,7.5c0,1.7-0.2,3.2-4.1,5.2l-11.5,6c0.6-2.5,0.7-3,1.9-3.6l2.1-1.2c0.4-0.2,0.6-0.6,0.9-1.9l1.7-7.3c0.3-1.3-0.1-2.9-2.1-2.9c-2.8,0-3.6,1.4-4,3.3L44,34c-1.2,5.1-0.3,6.3,2.7,6.3c3,0,3.3-1.9,3.3-2.7c0-0.7-1-0.8-1-3c0-2.2,2.3-5.9,6.9-5.9c4.7,0,5,3.7,5,4.2C60.9,36.1,57.8,42,46.1,42z"/>
                            <path d="M82.6,10.7c-2.5,0-3.9,0.6-3.9,0.6L81.4,0h-13l-0.5,1.7c0,0,2.4,0.4,1.8,2.7l-5.8,25.1C61.9,38.3,65.8,42,76.6,42c9.1,0,12.9-5.3,13.5-7.9c0.6-2.6,2.8-12.4,2.8-12.4C94.4,15.7,92.9,10.8,82.6,10.7z M83.8,15.4c-0.4,1.8-4.9,21.2-4.9,21.2c-0.6,2.6-1.7,3.6-3.5,3.6c-3.2,0-3-1.7-2.2-5.1c0.5-2.1,4.4-19.2,4.4-19.2c0.4-1.6,1.4-3.5,3.9-3.5C83.9,12.5,84.1,14.1,83.8,15.4z"/>
                            <path d="M112.1,10.7c-12,0-14.7,4.7-16.3,11.7l-1.6,7.1C92,38.8,95.8,42,106.9,42c9.1,0,12.9-5.3,13.5-7.9c0.6-2.6,2.6-11.7,2.6-11.7C124.6,15.7,122.1,10.7,112.1,10.7z M114,15.4c-0.4,1.8-4.9,21.2-4.9,21.2c-0.6,2.6-1.7,3.6-3.4,3.6c-3.2,0-3-1.7-2.2-5.1c0.5-2.1,4.4-19.2,4.4-19.2c0.4-1.6,1.4-3.5,3.9-3.5C114.1,12.5,114.3,14.1,114,15.4z"/>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="landing-page__sandwich-wrap">
                <img src="images/sandwich-stack.svg" alt="Stacked Sandwiches" className="landing-page__sandwich d-none d-md-block" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/scripts/components/LandingPage.js